// extracted by mini-css-extract-plugin
module.exports = {"root":"G_b","dividerAnimation":"G_p"};